import { render, staticRenderFns } from "./OrderDetailList.vue?vue&type=template&id=28d630a2&scoped=true&"
import script from "./OrderDetailList.vue?vue&type=script&lang=js&"
export * from "./OrderDetailList.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailList.vue?vue&type=style&index=0&id=28d630a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d630a2",
  null
  
)

export default component.exports